<template>
  <div class="reject-order-info" v-if="rejectProductList.length">

    <!-- 无忧内容部分 -->
    <div class="reject-order-content">
      <div class="reject-order-title">
        <div class="title">
          保障顾客无忧出行，额外再赚¥50+
        </div>
        <!-- 评论 -->
        <scroll-up-animation :list="rejectCommentList" class="comment-list">
          <template  v-slot="{list}">
            <div class="comment-item" v-for="(comment,ind) in list" :key="ind">
              <img :src="comment.avatar" alt="" class="comment-img">
              <div class="comment-person-name">深圳***旅行社</div>
              <div class="comment-content">{{ comment.text }}</div>
            </div>
          </template>
        </scroll-up-animation>
      </div>

      <div class="reject-order-container">
        <div class="content-left">
          <div class="icon-box"></div>
          <div class="title">拒签无忧</div>
        </div>
        <div class="content-right">
          <!-- 无忧商品列表 -->
          <div class="reject-order-list">
            <div class="reject-order-product" v-for="(item,index) in rejectProductList" :key="index">
              <label>
                <div class="product-content">
                  <div class="product-left">
                    <div class="product-name">
                      {{ item.reject_product_name }}
                    </div>
                    <div class="product-radio">
                      <div class="icon icon-gou"></div>
                      拒签赔付<span class="weight">{{ item.ratio }}%</span>
                      &nbsp;·&nbsp;最高赔<span class="weight">¥{{ getReturnPrice(item) }}</span>
                    </div>
                  </div>

                  <div class="product-right">
                    <div class="product-price">+<span class="weight">{{ item.sell_price / 100  }}</span>元/人</div>
                  </div>
                </div>
              </label>
            </div>
            <!-- 无保障 -->
            <div class="reject-order-product">
              <label>
                <div class="product-content">
                  <div class="product-left">
                    <div class="product-name">
                      无保障
                    </div>
                    <div class="product-radio">
                      <div class="icon icon-cha"></div>
                      拒签无赔付
                    </div>
                  </div>

                  <div class="product-right">
                    <!-- <div class="product-price"><span class="weight">0</span>赔付</div> -->
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 无忧提示 -->
    <div class="reject-order-tips">
      <div class="tip">*最高可赔金额具体以付款页面为准</div>
      <div class="rule-tips">
        <span>购买拒签无忧服务需理解并同意</span>
        <span class="primary-key" @click="showRejectProductRules">
          须知声明
          <span class="tips-icon"></span>
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';
import scrollUpAnimation from '@/components/common/animation/scroll-up-animation.vue';
import productService from '../../../../services/product-service';

export default{
  components: {
    scrollUpAnimation,
  },
  props: {
    productDetail: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      expand: false,
      productListHeight: 0,
      selectedValue: 0,
    };
  },
  computed: {
    rejectProductList() {
      return this.productDetail && this.productDetail.reject_product_set ? this.productDetail.reject_product_set : [];
    },
    rejectCommentList() {
      return this.productDetail.reject_product_show_list || [];
    },
    getMaxRadio() {
      const returnPrinceList = this.rejectProductList.map(item => item.ratio);
      return Math.max.apply(null, returnPrinceList);
    },
    productShowPrice() {
      return productService.getSalesPrice(this.productDetail);
    },
  },
  watch: {
    expand: {
      handler() {
        this.$nextTick(() => {
          this.productListHeight = this.getHeight();
        });
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.rejectProductList) {
      const defaultProduct = this.rejectProductList.find(item => item.is_selected);
      if (defaultProduct) {
        this.selectedValue = defaultProduct.reject_product_id;
      }
    }
  },
  methods: {
    getHeight() {
      const itemHeight = 47;
      // 是否展开
      if (!this.expand) return itemHeight;

      const productListHeight = itemHeight * (this.rejectProductList.length + 1); // 加上无赔付
      const commentHeight = this.$refs.commentListRef ? this.$refs.commentListRef.offsetHeight : 0;
      return productListHeight + commentHeight;
    },
    // 显示规则
    showRejectProductRules() {
      NoticeModal.modal({
        title: '拒签无忧',
        message: this.productDetail.reject_product_rule,
        showCancelButton: false,
        showConfirmButton: false,
        isTextareaMessage: true,
        confirmButtonText: '我知道了',
        confirmMethod: () => {
        },
      });
    },
    // 拒签价格
    getReturnPrice(rejectProduct) {
      const productPrice = this.productShowPrice || 0;
      // 直接截取
      const resultPrice = productPrice * rejectProduct.ratio / 100;
      return (Math.floor(resultPrice * 100) / 100).toFixed(2);
    },

  },
};
</script>


<style lang="less" scoped>
.reject-order-info {
  margin-top: 12px;
  padding: 16px;
  font-size: 14px;
  background-color: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
  .reject-order-content {
    background: rgba(0,190,109,0.01);
    border-radius: 2px;
    border: 1px solid rgba(0,190,109,0.2);
    .reject-order-title {
      padding: 14px 12px;
      background: linear-gradient( 270deg, rgba(0,190,109,0) 0%, rgba(3,184,111,0.08) 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #03B86F;
        display: flex;
        align-items: center;
        .reject-show-title-icon {
          width: 22px;
          height: 25px;
          margin-right: 8px;
        }
      }

      .comment-list {
        flex: 1;
        .comment-item {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          >img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
          .comment-person-name {
            margin-left: 8px;
            color: #2F333D;
          }
          .comment-content {
            margin-left: 8px;
            color: #5F666E;
          }
        }
      }
    }

    // 无忧商品列表
    .reject-order-container{
      display: flex;
      align-items: stretch;
      .content-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-basis: 184px;
        position: relative;
        &::after {
          content: '';
          width: 1px;
          height: calc(~'100% - 24px');
          background: #E9EEF2;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .icon-box {
          width: 56px;
          height: 56px;
          background: #FFFFFF;
          box-shadow: 0px 5px 13px 0px rgba(214,215,214,0.46);
          border-radius: 50%;
          position: relative;
          &::after {
            content: '';
            display: inline-block;
            width: 28px;
            height: 32px;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            background: url(../../../../assets/imgs/ordering/title-safe-icon.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
        .title {
          margin-top: 8px;
          font-size: 14px;
          color: #2F333D;
          font-weight: 600;
        }
      }
      .content-right {
        flex: 1;
        padding: 0 12px;
        // 无忧商品列表
        .reject-order-list{
          padding: 2px 0;
          .reject-order-product {
            border-bottom: 1px dotted #E9EEF2;
            >label {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 14px 0;
            }
            // &:hover{
            //   background: #FFFFFF;
            //   box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.06);
            // }
            &:last-child {
              border-bottom: none;
            }
            .product-content {
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .product-left {
                flex-shrink: 0;
                display: flex;
                align-items: center;
                >div {
                  margin-left: 12px;
                  &:first-child {
                    margin-left: 0;
                  }
                }
                
                .product-name {
                  color: #2F333D;
                  font-weight: 600;
                  display: flex;
                  align-items: center;
                  padding-left: 20px;
                  min-width: 100px;
                }
                .product-radio {
                  color: #5F666E;
                  display: flex;
                  align-items: center;
                  margin-left: 20px;
                  line-height: 1;
                  .icon{
                    width: 14px;
                    height: 14px;
                    margin-right: 4px;
                    &.icon-gou {
                      background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/reject-product/gou.png) no-repeat center / 100% 100%;
                    }
                    &.icon-cha {
                      background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/reject-product/cha.png) no-repeat center / 100% 100%;
                    }
                  }
                  .weight{
                    color: #2F333D;
                  }
                }
              }

              .product-right {
                flex: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                font-size: 14px;
                color: #5F666E;
                .refund-price {
                  background: linear-gradient( 353deg, rgba(255,130,0,0) 0%, rgba(255,113,46,0.1) 100%);
                  border-radius: 2px;
                  border: 1px solid #FFDFBF;
                  color: #FF8033;
                  font-size: 12px;
                  height: 22px;
                  line-height: 22px;
                  padding: 0 5px;
                  &.no-refund {
                    color: #2F333D;
                    background: linear-gradient( 90deg, rgba(222,226,230,0.7) 0%, rgba(222,226,230,0) 100%);
                    border-radius: 2px;
                    border: 1px solid #DEE2E6;
                  }
                }
                .product-price {
                  color: #2F333D;
                  display: flex;
                  align-items: center;
                  line-height: 1;
                  .weight {
                    display: inline-block;
                    font-size: 16px;
                    line-height: 16px;
                    padding: 0 4px 0 2px;
                  }
                }
              }
            }
            .radio-li-icon {
              display: inline-block;
              width: 18px;
              height: 18px;
              background: url(../../../../assets/imgs/product/reject-product-no-checked.png) no-repeat center / 100% 100%;
              &.checked {
                background: url(../../../../assets/imgs/product/reject-product-checked.png) no-repeat center / 100% 100%;
              }
            }
          }
        }

      }
    }


    .expand-close-btn {
      color: #599FFF;
      font-weight: 600;
      text-align: center;
      padding: 16px 0;
      cursor: pointer;
      .arrow-icon{
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-left: 4px;
        transition: all .2s;
        background: url(../../../../assets/imgs/product-detail/icon-arrow-down.png) no-repeat center / 100% 100%;
        transform: rotate(180deg);
      }
      &.close .arrow-icon{
        transform: rotate(0deg);
      }
    }
  }
  .reject-order-tips {
    margin-top: 12px;
    color: #91999F;
    line-height: 20px;
    display: flex;
    align-items: center;
    .tip {
      padding-right: 12px;
      border-right: 1px solid rgba(145, 153, 159, .3);
    }
    .rule-tips {
      margin-left: 12px;
      display: flex;
      align-items: center;
      .primary-key {
        color: #599FFFFF;
        cursor: pointer;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .tips-icon{
        margin-left: 8px;
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 6px;
        background: url(../../../../assets/imgs/ordering/tips.png) no-repeat center / 100% 100%;
        vertical-align: bottom;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/product-info/components/reject-order-info.vue